import React from 'react';
import {
  ELIGIBILITY,
  EMPLOYMENT,
  HOUSEHOLD,
  MORE_DETAILS,
  MOVE_DETAILS,
  PERSONAL_INFO,
} from '@tmap/mmm-core/commonApp/funnelCategories';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';
import isWaitlist from '../../lib/incentive/isWaitlist';

function CommonAppHeadline({ stage, incentive }) {
  const headlineText = () => {
    switch (stage) {
      case ELIGIBILITY:
        if (isWaitlist(incentive)) {
          return `Let ${incentive.locationText} know that you are interested.`;
        }
        return 'Welcome to QuickApply';
      case PERSONAL_INFO:
        return 'Tell us a bit about you.';
      case MOVE_DETAILS:
        return 'Tell us about your move';
      case HOUSEHOLD:
        return 'Is anyone joining you?';
      case EMPLOYMENT:
        return 'What do you do for a living?';
      case MORE_DETAILS:
        return 'Stand out from the crowd.';
      default: return '';
    }
  };
  return (
    <Typography variant='h4' fontWeight={700}>
      {headlineText()}
    </Typography>
  );
}

export default CommonAppHeadline;
